import { render, staticRenderFns } from "./ExternalPurchases.vue?vue&type=template&id=91282ef2&scoped=true&"
import script from "./ExternalPurchases.vue?vue&type=script&lang=js&"
export * from "./ExternalPurchases.vue?vue&type=script&lang=js&"
import style0 from "./ExternalPurchases.vue?vue&type=style&index=0&id=91282ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91282ef2",
  null
  
)

export default component.exports